export default "__VITE_ASSET__BaAGJrd3__"